import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Slider from './components/Slider';
import Marcas from './components/Marcas';
import Equiposdestacados from './components/Equiposdestacados';
import EquipoDetalle from './components/EquipoDetalle';
import EquiposPorCategoria from './components/EquiposPorCategoria';
import Aquipos from './components/Aquipos';
import Eventos from './components/Eventos';
import EventoDetalle from './components/EventoDetalle';


// Componente para controlar la visibilidad
const VisibilityController = ({ children, showOnFirstLoad = false }) => {
  const [hasNavigated, setHasNavigated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Si no es la ruta inicial ("/"), significa que ha navegado
    if (location.pathname !== '/') {
      setHasNavigated(true);
    }
  }, [location.pathname]);

  // Mostrar si: es de primera carga O si ya ha navegado
  if (showOnFirstLoad || hasNavigated) {
    return children;
  }

  return null;
};

const Home = () => (
  <>
    <Hero />
     <VisibilityController showOnFirstLoad={true}>
      <Slider />
    </VisibilityController> 
     <VisibilityController showOnFirstLoad={true}>
      <Marcas />
    </VisibilityController> 
     <VisibilityController showOnFirstLoad={true}>
      <Equiposdestacados />
    </VisibilityController> 

    <VisibilityController>
      <Services />
    </VisibilityController>

    <VisibilityController>
      <Testimonials />
    </VisibilityController>

    <VisibilityController>
      <Blog />
    </VisibilityController>

    <VisibilityController>
      <Gallery />
    </VisibilityController>

{/*     <VisibilityController showOnFirstLoad={true}>
      <Contact />
    </VisibilityController> */}

  </>
);

const Nosotros = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <About />
     
    </div>
    <Contact />
  </>
);

const ServiciosPage = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Services />
      <Testimonials />
    </div>
    <Contact />
  </>
);

const BlogPage = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Blog />
    </div>
    <Contact />
  </>
);

const Galeria = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Gallery />
    </div>
    <Contact />
  </>
);

const Contacto = () => (
  <>
    <div className="min-h-screen pt-20 bg-white">
      <Contact />
    </div>
  </>
);


// Wrapper para la página de detalle (ya tiene su propio fondo negro)
const EquipoDetallePage = () => <EquipoDetalle />;

// Wrapper para la página de categoría (ya tiene su propio fondo negro)
const EquiposPorCategoriaPage = () => <EquiposPorCategoria />;

const AquiposPage = () => <Aquipos />;
const EventosPage = () => <Eventos />;


// Componente principal de la aplicación
function AppContent() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/galeria" element={<Galeria />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/equipo/:id" element={<EquipoDetalle />} />
        <Route path="/equiposPorCategoria" element={<EquiposPorCategoria />} />

        <Route path="/equipos/categoria/:id" element={<EquiposPorCategoriaPage />} />
          
          {/* Ruta para el detalle de un equipo específico */}
          <Route path="/equipo/:id" element={<EquipoDetallePage />} />
<Route path="/equipos" element={<AquiposPage />} />
<Route path="/eventos" element={<EventosPage />} /> 
<Route path="/evento/:slug" element={<EventoDetalle />} />


      </Routes>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AnimatePresence mode="wait">
        <AppContent />
      </AnimatePresence>
    </Router>
  );
}

export default App;